import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'timeFromMinutes' })
export class TimeFromMinutesPipe implements PipeTransform {
  transform(minutes: number | null | undefined): string | null {
    if (minutes === null || minutes === undefined) {
      return null;
    }

    const totalMinutes = Math.floor(minutes);
    const hours = Math.floor(totalMinutes / 60);
    const remainderMinutes = Math.abs(totalMinutes % 60);

    return `${hours.toString().padStart(2, '0')}:${remainderMinutes.toString().padStart(2, '0')}`;
  }
}
